import AuthService from "../auth-service/AuthService";

/**
 * Opens report-agent, the natural-language reporting app, signed in as whoever
 * is signed in here.
 *
 * There is no second password: report-agent takes this site's own access token,
 * asks this site's backend who the token belongs to, and mints its own session
 * from the answer. The token rides in the URL fragment, which browsers keep out
 * of the request and out of `Referer`, and report-agent wipes it from the
 * address bar before exchanging it.
 *
 * REACT_APP_REPORT_AGENT_SITE is this environment's key in report-agent's
 * MEDAI_SITES: it says which site to ask about the token, and report-agent
 * refuses any key it has not been configured with. Both variables unset means
 * the environment has no report-agent, and the menu entry does not appear.
 */
const BASE_URL = (process.env.REACT_APP_REPORT_AGENT_URL || "").replace(/\/+$/, "");
const SITE = process.env.REACT_APP_REPORT_AGENT_SITE || "";

function isEnabled() {
    return !!BASE_URL && !!SITE;
}

function open() {
    const token = AuthService.getAuthToken();
    if (!isEnabled() || !token) {
        return;
    }

    const url = `${BASE_URL}/sso#site=${encodeURIComponent(SITE)}&token=${encodeURIComponent(token)}`;
    // noopener: the new tab must not reach back into this one through
    // window.opener, and it carries a credential.
    window.open(url, "_blank", "noopener,noreferrer");
}

export default {
    isEnabled,
    open,
};
